import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export type MemberPayload = {
  projectId: string;
  memberIds: string[];
};

export type MemberResponse = {
  message: string;
  members: string[];
};

// Add members API call
const addMembers = async (payload: MemberPayload): Promise<MemberResponse> => {
  const { data } = await customAxios.post<MemberResponse>(
    "/projects/add-members",
    payload
  );
  return data;
};

// Remove members API call
const removeMembers = async (
  payload: MemberPayload
): Promise<MemberResponse> => {
  const { data } = await customAxios.post<MemberResponse>(
    "/projects/remove-members",
    payload
  );
  return data;
};

export const useAddProjectMembers = () =>
  useMutation<MemberResponse, AxiosError, MemberPayload>({
    mutationFn: addMembers,
    onSuccess: (data) =>
      showNotification({
        title: "Success",
        message: data.message,
        color: "green",
      }),
    onError: (error) =>
      showNotification({
        title: "Error",
        message:
          (error.response?.data as { message?: string })?.message ??
          "Failed to add project members",
        color: "red",
      }),
  });

// Hook for removing members
export const useRemoveProjectMembers = () =>
  useMutation<MemberResponse, AxiosError, MemberPayload>({
    mutationFn: removeMembers,
    onSuccess: (data) =>
      showNotification({
        title: "Success",
        message: data.message,
        color: "green",
      }),
    onError: (error) =>
      showNotification({
        title: "Error",
        message:
          (error.response?.data as { message?: string })?.message ??
          "Failed to remove project members",
        color: "red",
      }),
  });
